import {ActionService, ConfigurationService, JwtHttpClientService, ResourceModule} from "@fedeltapointofsale/data-client";
import {Inject, Injectable} from "@angular/core";

export class AccountPaymentUnapplyAction {
    constructor(public accountId: string, public receiptNo: string) {
    }
}

/**
 * Action Service to void an Account Payment
 */
@Injectable()
export class AccountPaymentUnapplyService extends ActionService {
    constructor(http: JwtHttpClientService,
                configService: ConfigurationService,
                @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) nameSpace,
                @Inject(ResourceModule.ACTION_NAMES_KEY) actionNames) {
        super(http, configService, nameSpace, actionNames, "account-payment-unapply");
    }
}
